module.exports = __webpack_public_path__ + "static/media/stepfour.3f98a2ed.gif";